import FeatureGates from '@atlaskit/feature-gate-js-client';

import type { ThirdPartyConfigsBootstrap } from '../../constants/schemas/3p-config';
import { GhostTextExperimentCohort } from '../quick-find/ghost-text';

export const serve3PGhostTextExperiment: ({
	thirdPartyConfigs,
}: {
	thirdPartyConfigs: ThirdPartyConfigsBootstrap;
}) => boolean = ({
	thirdPartyConfigs,
}: {
	thirdPartyConfigs: ThirdPartyConfigsBootstrap;
}): boolean => {
	const isEligible3PUser = Object.keys(thirdPartyConfigs).some(
		(productKey) => thirdPartyConfigs[productKey]?.userNeedsOAuth === false,
	);

	if (!isEligible3PUser) {
		return false;
	}

	return (
		FeatureGates.getExperimentValue<string>(
			'confluence_quick_find_ghost_text_3p_experiment',
			'cohort',
			GhostTextExperimentCohort.CONTROL,
		) === GhostTextExperimentCohort.THREE_P
	);
};
